import { LOGIN_CONST } from '../constant/page-constant'
import DRAFT_KEYS from '../../draft/Draft';

export const getLocalStorageCustom = name => {
    if (name) return localStorage.getItem(name)
    return null
}

export const setLocalStorageCustom = (name, value) => {
    if (name && value) localStorage.setItem(name, value)
}

export const setCookieCustom = (name, value, expires) => {
    document.cookie = `${name}=${value}; expires=${expires || ''}; Path=/;`
}

export const getCookieCustom = name => {
    try {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop().split(';').shift()
    } catch (err) {
        return null
    }
}

export const deleteCookieCustom = name => {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}

// Reusable draft persistence helpers
export const saveDraft = (key, data) => {
    if (key && data !== undefined) {
        localStorage.setItem(key, JSON.stringify(data));
    }
};

export const loadDraft = key => {
    if (key) {
        const raw = localStorage.getItem(key);
        if (raw) {
            try {
                return JSON.parse(raw);
            } catch (e) {
                return null;
            }
        }
    }
    return null;
};

export const clearDraft = key => {
    if (key) localStorage.removeItem(key);
};

export const clearAllDrafts = () => {
    Object.values(DRAFT_KEYS).forEach(key => {
        localStorage.removeItem(key);
    });
};
